import de from './de.json'
import type { ValidationI18nSchemaTypes } from './i18n'

export default { de }
export type { ValidationI18nSchemaTypes }
